import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import { Link as ScrollLink } from 'react-scroll';
import { useLocation } from 'react-router-dom'; // Importar useLocation
import SocialBtns from './SocialBtns';

export default function Hero({ data, socialData }) {
  const { imgUrl, name, heading, typingText, description, btnText } = data;

  // Obtener la ruta actual
  const location = useLocation();

  // Definir el enlace del CV en base a la ruta actual
  const resumeLink =
    location.pathname.startsWith('/es')
      ? 'https://drive.google.com/file/d/10qAKRXod_9Gc7AOMggsiZ1ZqMAw5tde9/view?usp=sharing' // Enlace al CV en español
      : 'https://drive.google.com/file/d/1vmkWkr9yvr_Q8Db99Q-7EVchHLbIjgCX/view?usp=sharing'; // Enlace al CV en inglés

  return (
    <section className="home-section" id="home" data-scroll-index={0}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="hs-text-box">
              <h6 data-aos="fade-up" data-aos-duration="1200">
                <span>{name}</span>
              </h6>

              <h1
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="100"
              >
                {heading}
              </h1>
              <h2
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="200"
              >
                <TypeAnimation
                  sequence={typingText}
                  speed={0}
                  repeat={Infinity}
                />
              </h2>
              <p
                className="text"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="300"
              >
                {description}
              </p>
              <div
                className="btn-bar d-flex align-items-sm-center flex-column flex-sm-row"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="400"
              >
                {/* Enlace dinámico del CV */}
                <a
                  href={resumeLink} // Enlace dinámico basado en el idioma
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-btn"
                >
                  <span>{btnText}</span>
                </a>
                <SocialBtns
                  socialBtns={socialData}
                  variant="ps-sm-4 pt-4 pt-sm-0 d-flex justify-content-center justify-content-sm-start"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hs-banner">
              <img src={imgUrl} title alt="Admin" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
